import { render, staticRenderFns } from "./downloadLink.vue?vue&type=template&id=28097385&scoped=true&"
import script from "./downloadLink.vue?vue&type=script&lang=js&"
export * from "./downloadLink.vue?vue&type=script&lang=js&"
import style0 from "./downloadLink.vue?vue&type=style&index=0&id=28097385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28097385",
  null
  
)

export default component.exports